import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { border } from 'styled-system';

import { Flex } from '../Flex';

const UnstyledFormGroupRow = styled(Flex)<any>`
  ${border};
`;

const FormGroupRow = (props: ComponentProps<typeof UnstyledFormGroupRow>) => (
  <UnstyledFormGroupRow
    m="sp_0"
    mb="sp_16"
    p="sp_0"
    border="none"
    alignItems="flex-start"
    flexDirection="column"
    {...props}
  />
);

export default FormGroupRow;
